import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './App.css';
import { Toaster } from '@/components/ui/sonner';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import MaidServicesSpecialOfferPage from './pages/MaidServicesSpecialOfferPage';
import BookingWizard from './components/BookingWizard';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_a8d7742a-37ee-46c6-9b13-96f9a03935e4/artifacts/m1p9gmst_Lava%20Logo.png';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/faq', label: 'FAQ' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

function PublicLayout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="App">
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <Link to="/" className="logo" data-testid="main-logo">
              <img src={LOGO_URL} alt="Lava Co" className="logo-image" />
            </Link>
            <div className="nav-menu">
              {NAV_LINKS.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  className={`nav-link ${location.pathname === l.to ? 'nav-link-active' : ''}`}
                  data-testid={`nav-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </Link>
              ))}
            </div>
            <div className="nav-actions">
              <Link to="/book" className="btn btn-primary nav-book-btn" data-testid="nav-book-now">
                Book Now
              </Link>
              <button
                className="nav-toggle"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
                data-testid="nav-mobile-toggle"
              >
                {menuOpen ? <X size={22} /> : <Menu size={22} />}
              </button>
            </div>
          </div>
          {menuOpen && (
            <div className="mobile-menu" data-testid="mobile-menu">
              {NAV_LINKS.map((l) => (
                <Link key={l.to} to={l.to} className="mobile-menu-link" onClick={() => setMenuOpen(false)}>
                  {l.label}
                </Link>
              ))}
              <Link to="/book" className="btn btn-primary mobile-menu-book" onClick={() => setMenuOpen(false)}>
                Book Now
              </Link>
            </div>
          )}
        </div>
      </nav>

      <main className="main-content">{children}</main>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <img src={LOGO_URL} alt="Lava Co" className="footer-logo" />
              <p>Premium cleaning services with transparent pricing</p>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <Link to="/services">Services</Link>
              <Link to="/faq">FAQ</Link>
              <Link to="/about">About Us</Link>
              <Link to="/book">Book a Cleaning</Link>
            </div>
            <div className="footer-section">
              <h4>Service Area</h4>
              <p>Los Angeles, CA</p>
              <p>& surrounding areas</p>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>(424) 485-1880</p>
              <p>info@lavacomanagement.com</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 Lava Co. All rights reserved. Serving Los Angeles & surrounding areas.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
        <Route path="/services" element={<PublicLayout><ServicesPage /></PublicLayout>} />
        <Route path="/faq" element={<PublicLayout><FAQPage /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
        <Route path="/maid-services-special-offer" element={<PublicLayout><MaidServicesSpecialOfferPage /></PublicLayout>} />
        <Route path="/book" element={<PublicLayout><BookingWizard /></PublicLayout>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </Router>
  );
}

export default App;
